//eixo 3 graduate_student
var graduate_student = [{
  info: "Atualização 1",
  number: "80"
},
{
  info: "Aperfeiçoamento 1",
  number: "70"
},
{
  info: "Complementação",
  number: "75"
},
{
  info: "Atualização 2",
  number: "75"
},
{
  info: "Aperfeiçoamento 2",
  number: "65"
},
{
  info: "Total",
  number: "73"
}
];


//eixo 3 students_profession
var students_profession = [{
  info: "Enfermeiro (a)",
  number: "63.9"
},
{
  info: "Outros Profissionais da Saúde",
  number: "12.7"
},
{
  info: "Médico (a)",
  number: "10.8"
},
{
  info: "Técnico(a) da área da saúde",
  number: "8.7"
},
{
  info: "Outros",
  number: "3.9"
}];


//eixo 3 students_performance
var students_performance = [{
  info: "Vigilância",
  number: "26.3"
},
{
  info: "Secretaria de Saúde (sem especificação)",
  number: "18.7"
},
{
  info: "Hospitalar",
  number: "15.8"
},
{
  info: "Atenção básica",
  number: "12.8"
},
{
  info: "Saúde Pública",
  number: "9.1"
},
{
  info: "Gestão de Programas de Saúde",
  number: "5.4"
},
{
  info: "Ensino",
  number: "3.9"
},
{
  info: "Saúde Indígena",
  number: "2.1"
},
{
  info: "Estudante (ensino médio e universitário)",
  number: "2.0"
},
{
  info: "Justiça",
  number: "0.3"
},
{
  info: "Outros",
  number: "3.6"
}];

export { graduate_student, students_profession, students_performance }